import _ from 'lodash'

export default iban

function iban() {
    const EVERY_FOUR_CHARS = /(.{4})(?!$)/g

    return (value) => {
        return _.isString(value) ? value.replace(EVERY_FOUR_CHARS, '$1 ') : value
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/iban.js